"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireDefault(require("../Tooltip/Tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StatBar = function StatBar(_ref) {
  var stats = _ref.stats,
    percentage = _ref.percentage,
    className = _ref.className;
  if (stats.length <= 0) return;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-statbar grid-x align-center " + (className || '')
  }, stats.map(function (item, index) {
    return item.description ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      key: index,
      className: "uk-statbar__stat cell auto text-center",
      trigger: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("strong", null, item.stat, " ", percentage ? '%' : item.percentage ? '%' : null), /*#__PURE__*/_react.default.createElement("h3", null, item.label))
    }, item.description) : /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "uk-statbar__stat cell auto text-center"
    }, /*#__PURE__*/_react.default.createElement("strong", null, item.stat, " ", percentage ? '%' : item.percentage ? '%' : null), /*#__PURE__*/_react.default.createElement("h3", null, item.label));
  }));
};
StatBar.propTypes = {
  /**
   * Take an array of objects of data
   */
  stats: _propTypes.default.any.isRequired,
  /**
   * Percentage by default
   */
  percentage: _propTypes.default.bool
};
StatBar.defaultProps = {
  stats: [],
  percentage: false
};
var _default = exports.default = StatBar;